import api from "./api";

export interface TipoProjeto {
  id: string;
  slug: string;
  label: string;
  cor: string | null;
  icone: string;
  ativo: boolean;
  ordem: number;
}

export async function listarTiposProjeto(opts?: { todos?: boolean }) {
  const r = await api.get(`/tipos-projeto${opts?.todos ? "?todos=1" : ""}`);
  return r.data.data as TipoProjeto[];
}

export async function criarTipoProjeto(dados: {
  label: string;
  slug?: string;
  cor?: string | null;
  icone?: string;
  ordem?: number;
  ativo?: boolean;
}) {
  const r = await api.post("/tipos-projeto", dados);
  return r.data.data as TipoProjeto;
}

export async function atualizarTipoProjeto(
  id: string,
  dados: Partial<{ label: string; cor: string | null; icone: string; ativo: boolean; ordem: number }>,
) {
  const r = await api.patch(`/tipos-projeto/${id}`, dados);
  return r.data.data as TipoProjeto;
}

export async function excluirTipoProjeto(id: string) {
  await api.delete(`/tipos-projeto/${id}`);
}

// === Categorias atribuídas a um usuário ===
export async function listarCategoriasUsuario(usuarioId: string) {
  const r = await api.get(`/usuarios/${usuarioId}/categorias`);
  return r.data.data as TipoProjeto[];
}

export async function definirCategoriasUsuario(usuarioId: string, tipoProjetoIds: string[]) {
  const r = await api.put(`/usuarios/${usuarioId}/categorias`, { tipoProjetoIds });
  return r.data.data as TipoProjeto[];
}
